import React from 'react';
import MisPreguntas from '../../components/MisPreguntas';

const MisPreguntasPage = () => (
	<MisPreguntas />
);

export default MisPreguntasPage;
